// extracted by mini-css-extract-plugin
export var icon = "_a2-3";
export var subtitle = "_a2-2";
export var title = "_a2-1";
export var value = "_a2-0";